export default "__VITE_ASSET__BV$$3ik1__"